import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie'

// import transaction from '@/pages/personal/transaction'
// const about = r => require.ensure([], () => r(require('@/pages/about')), 'about')
const partner = r => require.ensure([], () => r(require('@/pages/partner')), 'partner')
const home = r => require.ensure([], () => r(require('@/pages/home')), 'home')

const homeNew = r => require.ensure([], () => r(require('@/pages/homeNew')), 'homeNew')
const newHome = r => require.ensure([], () => r(require('@/pages/newhome')), 'newHome')
const product = r => require.ensure([], () => r(require('@/pages/products')), 'product')
const recurit = r => require.ensure([], () => r(require('@/pages/recurit')), 'recurit')
const newRecurit = r => require.ensure([], () => r(require('@/pages/recurit/newIndex')), 'newRecurit')
const conmanyInduce = r => require.ensure([], () => r(require('@/components/recurit/companyInduce')), 'conmanyInduce')
const mession = r => require.ensure([], () => r(require('@/components/recurit/mession')), 'mession')
const recuritTab = r => require.ensure([], () => r(require('@/components/recurit/recurit')), 'recuritTab')
const dd = r => require.ensure([], () => r(require('@/pages/dd')), 'dd')
const service = r => require.ensure([], () => r(require('@/pages/service')), 'service')
const login = r => require.ensure([], () => r(require('@/pages/loginSign/login')), 'login')
const signUp = r => require.ensure([], () => r(require('@/pages/loginSign/signup')), 'signUp')
const forget = r => require.ensure([], () => r(require('@/pages/loginSign/forget')), 'forget')
const direction = r => require.ensure([], () => r(require('@/pages/direction')), 'direction')
const ashare = r => require.ensure([], () => r(require('@/pages/enterprise/ashare')), 'ashare')
const paysumAShare = r => require.ensure([], () => r(require('@/pages/purchase/paysumashare')), 'paysumAShare')
const paysumOcs = r => require.ensure([], () => r(require('@/pages/purchase/paysumocs')), 'paysumOcs')
const paysum = r => require.ensure([], () => r(require('@/pages/purchase/paysum')), 'paysum')
// 个人中心
const dataAudit = r => require.ensure([], () => r(require('@/pages/personal/dataAudit')), 'dataAudit')
const customization = r => require.ensure([], () => r(require('@/pages/personal/customization')), 'customization')
const pay = r => require.ensure([], () => r(require('@/pages/personal/pay')), 'pay')
const userInfo = r => require.ensure([], () => r(require('@/pages/personal/userinfo')), 'userInfo')
const resetPassword = r => require.ensure([], () => r(require('@/pages/loginSign/resetPassword')), 'resetPassword')
const indentify = r => require.ensure([], () => r(require('@/pages/personal/identify')), 'indentify')
const duediligence = r => require.ensure([], () => r(require('@/pages/dd/duediligence')), 'duediligence')
// 购买页面
const purchase = r => require.ensure([], () => r(require('@/pages/purchase')), 'purchase')
const chargeSuccess = r => require.ensure([], () => r(require('@/pages/purchase/chargeSuccess')), 'chargeSuccess')
const payWeChat = r => require.ensure([], () => r(require('@/pages/purchase/paywechat')), 'payWeChat')
// 中概股
const ocs = r => require.ensure([], () => r(require('@/pages/enterprise/ocs')), 'ocs')
// 未上市
const unlisted = r => require.ensure([], () => r(require('@/pages/enterprise/unlisted')), 'unlisted')
// 定制化
const custom = r => require.ensure([], () => r(require('@/pages/enterprise/custom')), 'custom')
// API文档
const api = r => require.ensure([], () => r(require('@/pages/api')), 'api')
const apiIntroduction = r => require.ensure([], () => r(require('@/components/api/introduction')), 'apiIntroduction')
const apiBrandDate = r => require.ensure([], () => r(require('@/components/api/brandDate')), 'apiBrandDate')
const apiHelp = r => require.ensure([], () => r(require('@/components/api/help')), 'apiHelp')
const apiLogin = r => require.ensure([], () => r(require('@/components/api/login')), 'apiLogin')
const apiBrand = r => require.ensure([], () => r(require('@/components/api/brand')), 'apiBrand')
const apiLog = r => require.ensure([], () => r(require('@/components/api/log')), 'apiLog')
// BBT新产品
const bbt = r => require.ensure([], () => r(require('@/pages/BBT')), 'bbt')
const bbt1 = r => require.ensure([], () => r(require('@/pages/BBT')), 'bbt')
const bbtIntroduction = r => require.ensure([], () => r(require('@/components/BBT/bbtintroduction')), 'bbtIntroduction')
const bbtLink = r => require.ensure([], () => r(require('@/components/BBT/bbtlink')), 'bbtLink')
// 全A指数
const Aindex = r => require.ensure([], () => r(require('@/pages/Aindex')), 'Aindex')
const AindexIntroduction = r => require.ensure([], () => r(require('@/components/Aindex/Aindexintroduction')), 'AindexIntroduction')
const AindexLink = r => require.ensure([], () => r(require('@/components/Aindex/Aindexlink')), 'AindexLink')
// 情绪指数
const sentiment = r => require.ensure([], () => r(require('@/pages/sentiment')), 'sentiment')
// 新的情绪因子页面
const emotion = r => require.ensure([], () => r(require('@/pages/emotion')), 'emotion')
const liang = r => require.ensure([], () => r(require('@/components/emotion/liang')), 'liang')
const ge = r => require.ensure([], () => r(require('@/components/emotion/ge')), 'ge')
const hang = r => require.ensure([], () => r(require('@/components/emotion/hang')), 'hang')
const zhi = r => require.ensure([], () => r(require('@/components/emotion/zhi')), 'zhi')
// 电商和直播标准化
const onlineRetailers = r => require.ensure([], () => r(require('@/pages/onlineRetailers')), 'retailers')
const keys = r => require.ensure([], () => r(require('@/components/retailers/keys')), 'keys')
const gmv = r => require.ensure([], () => r(require('@/components/retailers/gmv')), 'gmv')
const sales = r => require.ensure([], () => r(require('@/components/retailers/sales')), 'sales')
const skuCategory = r => require.ensure([], () => r(require('@/components/retailers/skuCategory')), 'skuCategory')
const skuPrice = r => require.ensure([], () => r(require('@/components/retailers/skuPrice')), 'skuPrice')
const brandPavilion = r => require.ensure([], () => r(require('@/components/retailers/brandPavilion')), 'brandPavilion')
// 直播标准化
const liveBroadcast = r => require.ensure([], () => r(require('@/pages/liveBroadcast')), 'liveBroadcast')
// 文章
const article = r => require.ensure([], () => r(require('@/pages/article')), 'skuPrice')

// 品牌馆
const sport = r => require.ensure([], () => r(require('@/pages/sport')), 'sport')

// 数据下载
const dataDownload = r => require.ensure([], () => r(require('@/pages/dataDownload')), 'dataDownload')

const gptTalk = r => require.ensure([], () => r(require('@/pages/gptTalk')), 'gptTalk')

Vue.use(Router)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: home
  // },
  {
    path: '/sport',
    component: sport,
    name: 'sport'
  },
  {
    path: '/newHome',
    name: 'newHome',
    component: newHome
  },
  {
    path: '/gptTalk',
    name: 'gptTalk',
    component: gptTalk
  },
  {
    path: '/',
    name: 'homeNew',
    component: homeNew
  },
  {
    path: '/product',
    name: 'product',
    component: product
  }, {
    path: '/newRecurit',
    name: 'newRecurit',
    component: newRecurit,
    children: [{
      path: '/componyInduce',
      component: conmanyInduce
    }, {
      path: '/mession',
      component: mession
    }, {
      path: '/recurit',
      component: recuritTab
    }]

  }, {
    path: '/recurit',
    name: 'recurit',
    component: recurit
  }, {
    path: '/duediligence',
    name: 'duediligence',
    component: duediligence,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/partner',
    name: 'partner',
    component: partner
  }, {
    path: '/service',
    name: 'service',
    component: service
  }, {
    path: '/dd',
    name: 'dd',
    component: dd
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/signup',
    name: 'signup',
    component: signUp
  }, {
    path: '/forgetPassword',
    name: 'forgetpassword',
    component: forget
  }, {
    path: '/direction',
    name: 'direction',
    component: direction,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/direct/:tab',
    name: 'directionWithTab',
    component: direction,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/ashare',
    name: 'ashare',
    component: ashare,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/paysumAShare',
    name: 'paysumAShare',
    component: paysumAShare,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/paysumOcs',
    name: 'paysumOcs',
    component: paysumOcs,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/paysum/:paysumId',
    name: 'paysum',
    component: paysum,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/unlisted',
    name: 'unlisted',
    component: unlisted
  }, {
    path: '/purchase/:enterprise',
    name: 'purchase',
    component: purchase,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/userInfo',
    component: userInfo,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/pay',
    name: 'pay',
    component: pay,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/payWeChat',
    name: 'payWeChat',
    component: payWeChat,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/chargeSuccess',
    name: 'chargeSuccess',
    component: chargeSuccess,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/dataAudit',
    name: 'dataAudit',
    component: dataAudit,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/customization',
    name: 'customization',
    component: customization,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/resetPassword',
    component: resetPassword,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/identify',
    component: indentify,
    name: 'identify',
    meta: {
      requireAuth: true
    }
  }, {
    path: '/enterprise/ocs/:id',
    component: ocs,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/enterprise/unlisted/:id',
    component: unlisted,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/enterprise/custom/:id',
    component: custom,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/dataDownload',
    component: dataDownload
  }, {
    path: '/document',
    component: api,
    children: [{
      path: '', component: apiIntroduction
    }, {
      path: 'brand', component: apiBrand
    }, {
      path: 'brandDate', component: apiBrandDate
    }, {
      path: 'login', component: apiLogin
    }, {
      path: 'help', component: apiHelp
    }, {
      path: 'log', component: apiLog
    }]
  },
  // {
  //   path: '/newproduct/:id',
  //   component: bbt,
  //   meta: {
  //     requireAuth: true
  //   }
  // },
  {
    path: '/newproduct',
    component: bbt,
    children: [{
      path: '', component: bbtIntroduction
    }, {
      path: 'bbtlink',
      component: bbtLink,
      meta: {
        requireAuth: false
      }
    }]

  },
  {
    path: '/Aindex',
    component: Aindex,
    children: [{
      path: '', component: AindexIntroduction
    }, {
      path: 'Aindexlink',
      component: AindexLink,
      meta: {
        requireAuth: true
      }
    }]

  },
  {
    path: '/sentiment',
    component: sentiment
  }, {
    path: '/emotion',
    component: emotion,
    children: [
      {
        path: 'liang', component: liang
      }, {
        path: '', component: ge
      }, {
        path: 'hang', component: hang
      }, {
        path: 'zhi', component: zhi
      }
    ]

  }, {
    path: '/retailers/:id',
    component: onlineRetailers,
    children: [
      {
        path: '', name: 'keys', component: keys
      }, {
        path: 'gmv', name: 'gmv', component: gmv
      }, {
        path: 'sales', name: 'sales', component: sales
      }, {
        path: 'skuCategory', name: 'skuCategory', component: skuCategory
      }, {
        path: 'skuPrice', name: 'skuPrice', component: skuPrice
      }, {
        path: 'brandPavilion', name: 'brandPavilion', component: brandPavilion
      }
    ]

  }, {
    path: '/article/:id',
    component: article
  }, {
    path: '/liveBroadcast/:id',
    component: liveBroadcast
  }
]
const router = new Router({
  // hash history
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  // 不匹配，返回首页
  if (to.matched.length === 0) {
    from.name ? next({name: from.name}) : next('/')
  } else {
    next()
  }
  // 路由拦截
  if (to.meta.requireAuth) {
    if (VueCookie.get('token')) next()
    else {
      next({path: '/login'})
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js